<template>
  <div v-if="flag">
    <slot :options="options" :list="list" :navTo="navTo"></slot>
  </div>
</template>
<script>
  import bannerService from '@/services/bylBaseCenter/base/banner'
  export default {
    data() {
      return {
        flag: false,
        options: {
          currentPage: 0,
          thresholdDistance: 500,
          thresholdTime: 100,
          autoplay: 10000,
          loop: true,
          direction: 'horizontal',
          loopedSlides: 1,
          slidesToScroll: 1,
          timingFunction: 'ease',
          speed: 300,
          renderPagination: (h, index) => {
            return h('span', {
              class: 'b-hsm-list-span'
            })
          },
          tap (data) {
            console.log(data)
          }
        },
        list: []
      }
    },
    mounted () {
      bannerService.getBanners({audit: '1'}).then((r) => {
        var a = []
        r.data.forEach((o) => {
          let no = {}
          no.style = {
            'background': 'url(' + o.cover + ') no-repeat center center',
            'background-size': '1200px 400px',
            'width': '1200px',
            'height': '400px',
            'cursor': 'pointer'
          }
          no.href = o.href
          a.push(no)
        })
        this.list = a
        this.flag = true
      })
    },
    methods: {
      navTo (item) {
        if (item.href) {
          if (this.isInternal(item.href)) {
            this.$projCommon.navTo({path: this.createRoute(item.href)}, {})
          } else {
            window.open((item.href.indexOf('http') <= 0) ? 'http://' + item.href : item.href, '_blank')
          }
        }
      },
      isInternal (href) {
        return href.split('/')[0] == 'internalink'
      },
      createRoute (href) {
        let isInternal = this.isInternal(href)
        if (isInternal) {
          let t = this.createResourceRoute(href.split('/')[1])
          return t + '/' + href.split('/')[2]
        } else {
          console.log(href)
          return href
        }
      },
      createResourceRoute (c) {
        switch (c) {
          case '1': {
            return '/plan'
          }
          case '2': {
            return '/courseDetail'
          }
          case '3': {
            return '/enroll'
          }
          case'4': {
            return '/kb'
          }
        }
      }
    }
  }
</script>
<style>
  .b-hsm-list-span {
    display: inline-block;
    cursor:pointer;
    width:34px;
    height:5px;
    background-color: rgba(0,0,0,0.8);
    margin: 0 5px;
    text-align:justify;
  }
  .b-hsm-list-span.slider-pagination-bullet-active-render { background: red }
</style>



// WEBPACK FOOTER //
// src/containers/banner/containerBanner.vue